<div class="mt-filter filter-shift">
    <div class="title">
        <span class="label">{{'shift_' | lang}}</span>
        <span *ngIf="filter.required" class="mandatory">*</span>
    </div>

    <div class="filter">
        <app-dropdown-selector
            label=""
            [items]="shifts"
            bindLabel="name"
            bindValue="shiftId"
            [multiselect]="filter.multiselect ? true : false"
            [allSelectedOption]="filter.multiselect ? true : false"
            [ngModel]="selectedOption"
            (ngModelChange)="changeSelectedShift($event)">
        </app-dropdown-selector>
    </div>
</div>